export class GetBorrowerPaneWidth {
  static readonly type = '[TodayPage] GetBorrowerPaneWidth';
  constructor() {}
}

export class SetBorrowerPaneWidth {
  static readonly type = '[TodayPage] SetBorrowerPaneWidth';
  constructor(
    public borrowerPaneWidth: number
  ) {}
}
